<template>
  <div class='RegisterProdMobile'>
    <input-img/>
    <div class="cont">
      <input-select
      v-if="Theme.name != 'Modelo 03'"
      :value="SelectedProdEdit.tipo"
      @update:model-value="newValue => ChangeProdEdit({ tipo: newValue })"
      :data="types"
      text="Tipo"
      :cont="{ width: '100%' }"
      :label="{ textAlign: 'left', marginTop: '5px', marginLeft: '3px' }"
      :input="{ width: '100%', padding: '4%', fontSize: '16px', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      />
    </div>
    <div class="cont destaque">
      <input
      :checked="SelectedProdEdit.destaque"
      @change="ChangeProdEdit({ destaque: !SelectedProdEdit.destaque })"
      type="checkbox"
      />
      <div>Destaque</div>
    </div>
    <div class="cont">
      <input-reg
      :value="SelectedProdEdit.code"
      @update:model-value="newValue => ChangeProdEdit({ code: newValue })"
      text="Código"
      :cont="{ textAlign: 'left' }"
      :label="{ marginLeft: '3px' }"
      :input="{ fontSize: '26px', padding: '1.5%', width: '96%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      />
    </div>
    <div class="cont">
      <input-reg
      :value="SelectedProdEdit.name"
      @update:model-value="newValue => ChangeProdEdit({ name: newValue })"
      :text="Empresa.modelo === 'Modelo 03' ? 'Nome do imóvel' : 'Nome do produto'"
      :cont="{ textAlign: 'left' }"
      :label="{ marginLeft: '3px' }"
      :input="{ fontSize: '26px', padding: '1.5%', width: '96%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      />
    </div>
    <div class="cont">
      <input-reg
      :value="SelectedProdEdit.preco"
      @update:model-value="newValue => ChangeProdEdit({ preco: newValue })"
      text="Preço (R$)"
      :cont="{ textAlign: 'left' }"
      :label="{ marginLeft: '3px' }"
      :input="{ textAlign: 'right', fontSize: '26px', padding: '1.5%', width: '96%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      Money
      />
    </div>
    <div class="cont">
      <input-reg
      :value="SelectedProdEdit.oferta"
      @update:model-value="newValue => verifyOferta(newValue)"
      text="Preço de oferta (R$)"
      :cont="{ textAlign: 'left' }"
      :label="{ marginLeft: '3px' }"
      :input="{ textAlign: 'right', fontSize: '26px', padding: '1.5%', width: '96%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      Money
      />
    </div>
    <div class="cont">
      <input-crono/>
    </div>
    <div class="cont">
      <input-text
      :value="SelectedProdEdit.descricao"
      @update:model-value="newValue => ChangeProdEdit({ descricao: newValue })"
      :text="Empresa.modelo === 'Modelo 03' ? 'Descrição do imóvel' : 'Descrição do produto'"
      :label="{ textAlign: 'left', marginLeft: '3px', marginTop: '5px' }"
      :input="{ padding: '2%', fontSize: '18px', width: '95%', border: 'thin solid #CCC', borderRadius: '5px' }"
      rows="5"
      />
    </div>
    <div class="cont">
      <visib-prod/>
    </div>
    <div class="cont" v-if="Theme.name != 'Modelo 03'">
      <estoque-prod/>
    </div>
    <div class="cont" v-if="SelectedProdEdit.tipo === 'Variável'">
      <props-prod/>
    </div>
    <div class="cont" v-if="Empresa.modelo === 'Modelo 03'">
      <input-caracter/>
    </div>
    <div class="cont">
      <button v-if="!edit" @click="push">Salvar</button>
      <button v-if="edit" @click="update">Atualizar</button>
    </div>
  </div>
</template>

<script>
import InputSelect from './InputSelect'
import InputReg from './InputReg'
import { mapGetters, mapActions } from 'vuex'
import InputCrono from './InputCrono'
import InputText from './InputText'
import VisibProd from './VisibProd'
import EstoqueProd from './EstoqueProd'
import PropsProd from './PropsProd'
import InputCaracter from './InputCaracter'
import InputImg from './InputImg.vue'
export default {
  name: 'RegisterProdMobile',
  components: { InputSelect, InputReg, InputCrono, InputText, VisibProd, EstoqueProd, PropsProd, InputCaracter, InputImg },
  data () {
    return {
      types: [
        { name: 'Simples' },
        { name: 'Variável' }
      ],
      form: {
        name: ''
      }
    }
  },
  computed: {
    ...mapGetters(['SelectedProdEdit', 'Theme', 'Empresa']),
    edit () {
      return this.SelectedProdEdit.id !== ''
    }
  },
  methods: {
    ...mapActions(['ChangeProdEdit', 'PushProd', 'ClearProdEdit', 'PushMsg', 'VerifyPermission', 'SetModal', '_UpdateProduct']),
    verifyOferta (oferta) {
      let preco = parseFloat(this.SelectedProdEdit.preco.replace(/\./g, '').replace('R$ ', '').replace(',', '.'))
      let of = parseFloat(oferta.replace(/\./g, '').replace('R$ ', '').replace(',', '.'))
      if(of > preco) {
        this.PushMsg({ msg: 'O valor da oferta não pode ser maior que o valor do produto', color: 'orange' })
        this.ChangeProdEdit({ oferta: 0 })
        return
      }
      this.ChangeProdEdit({ oferta: oferta })
    }
  }
}
</script>

<style scoped>
.RegisterProdMobile {
  width: 100%;
  height: 75%;
  overflow: auto;
}

.cont {
  padding: 2%;
}

.destaque {
  display: flex;
  justify-content: center;
  padding-top: 0;
}

button {
  border: 0;
  font-size: 16px;
  padding: 1.5%;
  margin: 1%;
  border-radius: 5px;
  background-color: #333333;
  color: #FFFFFF;
  cursor: pointer;
}

@media (max-width: 500px) {
  .RegisterProdMobile {
    display: block;
  }
}

@media screen and (min-width: 500px) {
  .RegisterProdMobile {
    display: none;
  }
}
</style>
